module.exports = __webpack_public_path__ + "static/bb-ba6439ca8151500f0232e0157a6a6f5c.png";